import './missionupdate.less';
import * as _ from 'lodash';
import * as ApiWarnings from '../server/ApiWarnings';

angular.module("tromanWeb").controller('MissionUpdateController', ['$q', '$scope', 'tromanServer', 'ObjectCache', 'dialogService', 'missions', 'organization', 'person', function ($q, $scope, tromanServer, ObjectCache, dialogService, missions, organization, person) {

    var isSaving = false;

    this.pluralSuffix = missions.length === 1 ? 'et' : 'en';

    this.setStart = false;
    this.start = null;
    this.setEnd = false;
    this.end = null;
    this.copyop = 'none';
    this.vacantSamePeriod = false;
    this.mandate = null;
    this.valid = true;

    this.missions = missions;
    this.mandates = null;

    this.hasSameMissionType = _.uniqBy(missions, x => x.MissionTypeId).length <= 1;

    ObjectCache.getMissionTypes().then(x => this.missionTypes = x);

    if (organization != null) {
        this.organization = organization;
        
        if (angular.isArray(organization.MandatePeriods)) {
            var mpid = missions[0].MandatePeriodId;
            this._sameMandate = _.find(organization.MandatePeriods, x => x.Id === mpid);
            this.mandate = this._sameMandate;

            this.mandates = organization.MandatePeriods;
        }

    } else if (person != null) {
        this.person = person;
    }

    this.mandateTitle = function mandateTitle(mp) {
        if (mp === this._sameMandate) {
            return mp.display + " (Samma period)";
        } else {
            return mp.display;
        }
    };

    this.willSetEnd = function () {
        return this.setEnd && this.end != null;
    };

    this._makeRequest = function _makeRequest() {
        var req = {
            CopyOperation: 0,
            Missions: this.missions.map(x => ({
                Id: x.Id,
                RowVersion: x.RowVersion
            })),
            CopyMissionTypeId: null,
            CopyMandatePeriodId: null,
        };

        if (this.setStart) {
            req.Start = this.start;
        }

        if (this.setEnd) {
            req.End = this.end;
        }

        if (this.copyop === 'vacant') {
            req.CopyOperation = 1;
        } else if (this.copyop === 'keep') {
            req.CopyOperation = 2;
        }

        if (this.missionTypeId) {
            req.CopyMissionTypeId = this.missionTypeId;
        }

        if (this.mandate != null) {
            req.CopyMandatePeriodId = this.mandate.Id;
        }

        return req;
    };

    this.canSave = function canSave() {
        return !isSaving;
    };

    this.save = function save() {

        if (!this.canSave()) return;

        this.editForm.$commitViewValue();
        this.editForm.$setSubmitted();

        if (this.editForm.$invalid) return;

        var req = this._makeRequest();

        isSaving = true;
        tromanServer.Missions.updateMultiple(req)
            .then(rsp => this.checkResponse(rsp))
            .then(() => {
                $scope.$close(true);
            })
            .catch(error => {
                this.error = error;
            })
            .finally(() => {
                isSaving = false;
            });
    };


    this.checkResponse = function checkResponse(rsp) {
        let ret = $q.when(rsp);

        if (_.has(rsp.warnings, ApiWarnings.PersonHasMultipleMissions)) {
            let personsWithMultiple = _.chain(rsp.warnings[ApiWarnings.PersonHasMultipleMissions])
                .castArray()
                .map(personId => _.find(this.missions, x => x.PersonId === personId)?.Person)
                .reject(_.isNil)
                .sortBy(['firstName', 'LastName'])
                .map(x => x.name)
                .value();

            let multipleMissionWarning = [
                'Följande personer har överlappande uppdrag.',
                personsWithMultiple.join('\n'),
            ];

            ret = ret.finally(() => dialogService.warning(multipleMissionWarning));
        }

        if (_.has(rsp.warnings, ApiWarnings.MissionInGroup)) {
            let missionsInGroup = _.chain(rsp.warnings[ApiWarnings.MissionInGroup])
                .castArray()
                .map(missionId => _.find(this.missions, x => x.Id === missionId))
                .reject(_.isNil)
                .sortBy(['Person.firstName', 'Person.LastName'])
                .map(x => `${x.Person?.name}, ${x.MissionType.Abbreviation}, ${x.MandatePeriod.Organization.Name}`)
                .value();

            let missionsInGroupWarning = [
                'Följande uppdrag finns i plocklista.',
                missionsInGroup.join('\n'),
            ];

            ret = ret.finally(() => dialogService.warning(missionsInGroupWarning));
        }

        return ret;
    };

    this.cancel = function cancel() {
        if (this.editForm.$dirty) {
            dialogService.confirm(["Det finns osparade ändringar som kommer gå förlorade.", "Är du säker?"]).then(() => {
                $scope.$dismiss("cancelled");
            });
        } else {
            $scope.$dismiss("cancelled");
        }
    };

}]);
